import { createFileRoute } from '@tanstack/react-router';
import { PersonAttributesEditRoute } from './-route-wrappers';

/** The person profile's attribute editor at its own URL (FPS-2706). */
function PersonAttributesEditFileRoute() {
  return <PersonAttributesEditRoute />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/attributes/edit')({
  component: PersonAttributesEditFileRoute,
});
